function show(msg, duration = 3000) {
  const toast = document.createElement('div')

  const isPortrait = window.matchMedia(
    '(orientation: portrait)'
  ).matches

  toast.innerText = msg

  let transform = ''

  if (isPortrait) {
    // 竖屏 -> 页面已被 rotate
    // toast 也 rotate，并向“视觉底部”移动
    transform = `
      translate(-50%, -50%)
      rotate(90deg)
      translateY(40vw)
    `
  } else {
    // 正常横屏
    transform = `
      translate(-50%, -50%)
    `
  }

  toast.style.cssText = `
    position: fixed;

    left: 50%;
    top: 50%;

    transform: ${transform};

    transform-origin: center center;

    color: #fff;
    background: rgba(0,0,0,0.75);

    padding: 10px 16px;
    border-radius: 8px;

    font-size: 14px;
    line-height: 1.4;

    z-index: 999999;

    opacity: 1;
    transition: opacity .3s ease;

    pointer-events: none;

    max-width: 80vw;
    text-align: center;

    word-break: break-word;
  `

  document.body.appendChild(toast)

  setTimeout(() => {
    toast.style.opacity = '0'

    setTimeout(() => {
      toast.remove()
    }, 300)
  }, duration)
}

export default {
  show
}